import React from "react";
import colors from '../../theme/variables/colors';
import { ProgramContainer } from "../../entities/formTemplateDataType";

interface Props {
    isEng: boolean;
    programContainer: ProgramContainer;
}



const FeedbackBannerComponent = ({isEng, programContainer} : Props) => {
 
    return (
        <div className="ontario-padding-top-16-! ontario-padding-bottom-16-!"
        style={{
            borderBottom: `.0625rem solid ${colors.palette.greyscale40}`,
            backgroundColor: colors.palette.systemLimeGreen,
            marginTop: '-56px', pointerEvents: "none"
        }}>
            <div className="ontario-row">
                <div className="ontario-column ontario-small-8" style={{pointerEvents: "auto"}}>
                   <span className="oer-badge-beta">{ isEng ? "beta" : "bêta" }</span>
                                              
                    { isEng ? " Share your " : " Faites-nous part de vos " } 
                    <a href={!!isEng ? programContainer.FeedbackURL : programContainer.FeedbackURLFRA} rel="noopener noreferrer" target="_blank">
                        { isEng ? "feedback" : "commentaires" }
                    </a>
                    { isEng ? " to help us improve our service." : " pour nous aider à améliorer notre service." }
                </div>
            </div>
        </div>
    );   
}

export default FeedbackBannerComponent;